import { DsTypography, IceLogo } from '@ice-web-app/designSystem';
import { Stack } from '@mui/material';
import CircularProgress, {
  CircularProgressProps,
  CircularProgressPropsColorOverrides,
} from '@mui/material/CircularProgress';
import { FC } from 'react';

export const MainLoading: FC = () => {
  return (
    <div className="flex flex-col justify-center items-center w-full h-full bg-blue-100">
      <CircularProgress size={50} />
      <p className="text-base font-semibold mt-4">Loading, Please wait...</p>
    </div>
  );
};

export const InnerLoading = ({
  size = 50,
  color = 'primary',
}: { size?: number; color?: CircularProgressProps['color'] }) => {
  return (
    <div className="flex flex-col justify-center items-center w-full h-full">
      <CircularProgress size={size} color={color} />
    </div>
  );
};

export const WebsiteLoading = ({ logo }: { logo: string }) => {
  return (
    <Stack
      justifyContent="center"
      gap={2}
      alignItems="center"
      sx={{
        width: '100%',
        height: '100vh',
        backgroundColor: ({ palette }) => palette.background.paper,
        position: 'fixed',
        top: 0,
        zIndex: 9999999999999,
      }}
    >
      <IceLogo style={{ width: '56px', height: '52px' }} />
      <DsTypography variant="body1_500" my={2}>
        Loading, Please wait...
      </DsTypography>
      <CircularProgress color="primary" />
    </Stack>
  );
};
